import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { FiltersOption } from "./constants";
import { MD } from "./mdTheme";
import { MdWidgetCard, MdPeriodSelect } from "./MdCardShell";
import { MdMoneyValue } from "./MdMoneyValue";

const BOX_STYLES = {
  blue: { bgcolor: "#eef5ff", borderColor: "#d7e6fb", color: MD.fg },
  green: { bgcolor: MD.goodSoft, borderColor: "#bfe9cf", color: "#166534" },
  amber: { bgcolor: MD.warnSoft, borderColor: "#fbd9a5", color: "#b45309" },
  red: { bgcolor: MD.badSoft, borderColor: "#f7c7c7", color: "#b91c1c" },
};

const DOT = {
  blue: MD.chart[0],
  green: MD.good,
  amber: MD.warn,
  red: MD.bad,
};

const MoneyBox = ({ tone, label, value, currency }) => {
  const style = BOX_STYLES[tone] || BOX_STYLES.blue;
  return (
    <Box
      sx={{
        ...style,
        alignItems: "center",
        border: `1px solid ${style.borderColor}`,
        borderRadius: "6px",
        display: "flex",
        gap: 0.75,
        minHeight: 32,
        px: 1,
        py: 0.5,
      }}
    >
      <Box
        sx={{
          bgcolor: DOT[tone] || DOT.blue,
          borderRadius: "50%",
          flex: "none",
          height: 7,
          width: 7,
        }}
      />
      <Typography
        noWrap
        title={label}
        sx={{
          color: "inherit",
          flex: 1,
          fontSize: 11,
          fontWeight: 500,
          m: 0,
          minWidth: 0,
        }}
      >
        {label}
      </Typography>
      <MdMoneyValue
        amount={value}
        currency={currency}
        fontSize={13}
        color="inherit"
        fontWeight={600}
      />
    </Box>
  );
};

const CollectionsBoxesCard = ({
  translate,
  loading,
  data,
  periodValue,
  onPeriodChange,
  loginUserCurrency,
}) => (
  <MdWidgetCard
    loading={loading}
    eyebrow={translate("collections")}
    infoTitle={translate("collectionsOutstandingInfo") || "Collections, overdue, advance payments and outstanding balance."}
    title={translate("collectionsAndOutstanding")}
    controls={
      onPeriodChange ? (
        <MdPeriodSelect
          value={periodValue}
          onChange={onPeriodChange}
          options={FiltersOption}
          fallbackLabel="ALL"
        />
      ) : null
    }
  >
    <Stack spacing={0.625} sx={{ mt: 0.5, flex: 1, justifyContent: "center" }}>
      <MoneyBox
        tone="red"
        label={translate("totalOverDue") || translate("overdue")}
        value={data?.totalOverDue}
        currency={loginUserCurrency}
      />
      <MoneyBox
        tone="green"
        label={translate("totalCollections") || translate("collections")}
        value={data?.totalPaid}
        currency={loginUserCurrency}
      />
      <MoneyBox
        tone="amber"
        label={translate("paymentBalance") || translate("outstanding")}
        value={data?.amountCredited}
        currency={loginUserCurrency}
      />
      <MoneyBox
        tone="blue"
        label={translate("totalOutstanding")}
        value={data?.totalOutstanding}
        currency={loginUserCurrency}
      />
    </Stack>
  </MdWidgetCard>
);

export default CollectionsBoxesCard;
